module.exports = __webpack_public_path__ + "static/media/ACMO.5e780738.svg";